import React from 'react';

import PropTypes from 'prop-types';
import { Container } from './styles';

import { Link } from 'react-scroll';

export default function ArrowDown({ toElement, className }) {
  return (
    <Container className={className}>
      <Link
        activeClass="active"
        to={toElement}
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        Conheça
      </Link>
    </Container>
  );
}
ArrowDown.propTypes = {
  toElement: PropTypes.string,
  className: PropTypes.string,
};
